var render = function () {
  var _vm$currentRound, _vm$currentRound$teac, _vm$currentRound2, _vm$currentRound2$tea, _vm$currentRound2$tea2, _vm$currentRound3;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _c('article', {
    attrs: {
      "slot": "content",
      "id": "math-sentences-content-container"
    },
    slot: "content"
  }, [(_vm$currentRound = _vm.currentRound) !== null && _vm$currentRound !== void 0 && (_vm$currentRound$teac = _vm$currentRound.teacherImage) !== null && _vm$currentRound$teac !== void 0 && _vm$currentRound$teac.image ? _c('img', {
    attrs: {
      "alt": "Round image",
      "src": (_vm$currentRound2 = _vm.currentRound) === null || _vm$currentRound2 === void 0 ? void 0 : (_vm$currentRound2$tea = _vm$currentRound2.teacherImage) === null || _vm$currentRound2$tea === void 0 ? void 0 : (_vm$currentRound2$tea2 = _vm$currentRound2$tea.image) === null || _vm$currentRound2$tea2 === void 0 ? void 0 : _vm$currentRound2$tea2.src
    }
  }) : _vm._e(), _c('div', {
    attrs: {
      "id": "steps"
    }
  }, [_c('text-display-list', {
    attrs: {
      "element": "div",
      "id": "input",
      "text-size": "medium"
    }
  }, _vm._l((_vm$currentRound3 = _vm.currentRound) === null || _vm$currentRound3 === void 0 ? void 0 : _vm$currentRound3.steps, function (step, stepIndex) {
    return _c('blinking-cursor-text', {
      key: ("step" + stepIndex),
      attrs: {
        "text": step.answer,
        "text-step": stepIndex
      }
    });
  }), 1)], 1)])], 2), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }